function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMpGe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m65.79,17.6v-5.08c0-.7-.57-1.27-1.27-1.27s-1.27.57-1.27,1.27v5.08h-2.54v-5.08c0-.7-.57-1.27-1.27-1.27s-1.27.57-1.27,1.27v5.08h-2.54v3.81c0,3.06,2.16,5.61,5.04,6.21v24.88c0,.83-.67,1.5-1.5,1.5s-1.5-.67-1.5-1.5v-3c0-2.48-2.02-4.5-4.5-4.5h-1.5V6C51.67,2.69,48.98,0,45.67,0H15.67C12.36,0,9.67,2.69,9.67,6v54c-3.31,0-6,2.69-6,6v4.5c0,.83.67,1.5,1.5,1.5h51c.83,0,1.5-.67,1.5-1.5v-4.5c0-3.31-2.69-6-6-6v-12h1.5c.83,0,1.5.67,1.5,1.5v3c0,2.48,2.02,4.5,4.5,4.5s4.5-2.02,4.5-4.5v-24.97c2.68-.74,4.65-3.2,4.65-6.12v-3.81h-2.54Zm-34.01,47.1h-2.27l-4.23-13.27h3.17l2.2,7.62,2.2-7.62h3.17l-4.24,13.27Zm2.27-25.73v2.85h-4.85v2.31h5.68v2.95h-8.68v-13.27h8.68v2.95h-5.68v2.21h4.85Zm11.63-13.44c0,.83-.67,1.5-1.5,1.5h-27c-.83,0-1.5-.67-1.5-1.5V7.5c0-.83.67-1.5,1.5-1.5h27c.83,0,1.5.67,1.5,1.5v18.03Z",
    style: {
      fill: "#333"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpGe);
export default __webpack_public_path__ + "static/media/MPGe.4c8ca4200a2f075aee832c9b3198f53d.svg";
export { ForwardRef as ReactComponent };